import Posts from './Posts';
import Pages from  './Pages';
import Profile from './Profile';
import Videos from './Videos';
import { HomePage, Menu, Categories, Users  } from './Governance';
import {categories} from './items'

export default {
  Posts,
  Pages,
  Profile,
  Videos,
  HomePage,
  Menu,
  Categories,
  Users,
  categories,
};



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/index.js